export const IS_AUTHENTICATED_LOCAL_STORAGE_KEY = 'b7F21asX';
export const PW = 'superagent77';

export const QUESTION_RESULT = {
  NONE: 'žiadne',
  BASIC: 'základné',
  ADVANCED: 'stredné',
  EXPERT: 'rozsiahle'
};
